import React, { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { ClientContactForm } from "./ClientContactForm";
import { ClientContactItem } from "./ClientContactItem";
import { getClientContactsByAccountPartyIdAsync, resetSelectedRecordObjectInState, DeleteSelectedAccountClientContactAsync } from "./ClientContactSlice";
import OffCanvas from '../../../common/OffCanvas';
import { KTIcon } from '../../../_metronic/helpers';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { ShowToast } from '../../../common/Toastr';
import { useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';


export const ClientContact = () => {
    //let AccountPartyId : number
    //AccountPartyId = 42599
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const AccountPartyId = params.get('AccountPartyId');
    const dispatch = useAppDispatch();
    const { clientContactList, isReload, selectedRecord } = useAppSelector((state) => state.clientContact)

    useEffect(() => {
        if (isReload) {
            dispatch(getClientContactsByAccountPartyIdAsync(AccountPartyId));
        }
    }, [isReload])
    useEffect(() => {
        dispatch(getClientContactsByAccountPartyIdAsync(AccountPartyId));

    }, [dispatch])
    const handleOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState())
    }
    const generalObject = {
        "name": (Object.keys(selectedRecord).length > 0 ? 'Update' : 'Add') + " Client Contact",
        "width": "700px",
        "componentName": < ClientContactForm AccountPartyId={AccountPartyId} />
    }
    const onDeleteSelectedClick = () => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(DeleteSelectedAccountClientContactAsync(clientContactList))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult[0].StatusCode === "200" ?
                                ShowToast("Client Contact delete Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult[0].ResponseMessage, "error", "toast-top-right");
                            // console.log('onDeleteClick-DeleteSelectedAccountEmployeeTypeAsync-originalPromiseResult', originalPromiseResult);
                        })
                        .catch((rejectedValueOrSerializedError) => {
                            ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                            //console.log('onDeleteClick-DeleteSelectedAccountEmployeeTypeAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
                        })
                }
            })
            .catch((error) => {
                console.log("ShowSwalWithConfirmation:error ", error);
            });

    }
    return (
        <>
            <div className="card card-custom">
                <div className="card-header">
                    <h3 className="card-title">Client Contact</h3>
                    <div className="card-toolbar">
                        <a id="kt_OffCanvas"
                            className='btn btn-sm btn-light-primary'
                            style={{ marginRight: '2px', display: clientContactList.every((item: any) => item.isSelected === 0) ? 'none' : 'none' }}
                            onClick={handleOnClickEvent}>
                            <KTIcon iconName='exit-up' className='fs-3' />{`Export`}
                        </a>
                        <a id="kt_OffCanvas"
                            className='btn btn-sm btn-light-primary'
                            style={{ marginRight: '2px', display: clientContactList.every((item: any) => item.isSelected === 0) ? 'block' : 'none' }}
                            onClick={handleOnClickEvent}>
                            <KTIcon iconName='plus' className='fs-3' />{`Add Client Contact`}
                        </a>
                        <div className="fw-bold me-5" style={{ marginRight: '2px', display: clientContactList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}>
                            <span className="me-2" data-kt-user-table-select="selected_count">{clientContactList.filter((item: any) => item.isSelected === 1).length}</span> Selected
                        </div>
                        <button type="button" className="btn btn-danger btn-sm" onClick={() => onDeleteSelectedClick()}
                            style={{ marginRight: '2px', display: clientContactList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}
                        >
                            Delete Selected
                        </button>
                    </div>
                </div>
                <div className="card-body">
                    <div className="table-responsive">
                        <ClientContactItem clientContactList={clientContactList}  AccountPartyId={AccountPartyId} />
                    </div>
                </div>
            </div>
            <OffCanvas obj={generalObject} />
        </>
    )


}